import { StateNode, TLStateNodeConstructor } from "tldraw"
import { CustomNudge } from "./CustomNudge"
import { CustomNudgeIdle } from "./CustomNudgeIdle"

export class CustomNudgeTool extends StateNode {
  static override id = "nudge"
  static override initial = "nudge-idle"

  static override isLockable = false
  static override children(): TLStateNodeConstructor[] {
    return [CustomNudge, CustomNudgeIdle]
  }
}
